<script setup lang="ts">
import { useRouter } from 'vue-router'
import { forgotPassword, login, runtimeConfig } from '@ck/auth'
import { CkButton } from '@ck/ui'
import logoUrl from '../../design-system/logo-ck.png'

const router = useRouter()

function enter() {
  if (!runtimeConfig.authRequired) {
    router.push('/')
    return
  }
  login()
}
</script>

<template>
  <div class="login">
    <div class="brand">
      <img :src="logoUrl" alt="CK Car Repair Service" />
      <h1>CK Car Repair Service</h1>
      <div class="ck-eyebrow">Operacional</div>
    </div>
    <div class="card">
      <h2>Acesse sua conta</h2>
      <p class="hint">Você será redirecionado ao provedor de identidade da CK Car Repair Service.</p>
      <CkButton class="cta" @click="enter">Entrar</CkButton>
      <button type="button" class="link-button" @click="forgotPassword">Recuperar senha</button>
    </div>
  </div>
</template>

<style scoped>
.login { min-height: 100vh; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: var(--space-8); padding: var(--space-6) var(--space-4); background: var(--ck-ink-900); }
.brand { text-align: center; }
.brand img { width: 72px; height: 128px; object-fit: contain; margin: 0 auto var(--space-3); }
.brand h1 { margin: 0; font-size: var(--fs-xl); font-family: var(--font-display); font-weight: var(--fw-extrabold); color: var(--ck-text-on-dark); }
.brand .ck-eyebrow { margin-top: var(--space-2); color: var(--ck-amber-400); }
.card { width: 100%; max-width: 400px; padding: var(--space-8) var(--space-6); border: 1px solid var(--ck-ink-600); border-radius: var(--radius-xl); background: var(--ck-ink-700); box-shadow: var(--shadow-lg); text-align: center; color: var(--ck-text-on-dark); }
.card h2 { margin: 0 0 var(--space-2); font-size: var(--fs-2xl); }
.hint { margin: 0 0 var(--space-6); color: var(--ck-text-on-dark-muted); font-size: var(--fs-sm); }
.cta { width: 100%; }
.link-button { display: block; margin: var(--space-6) auto 0; border: 0; background: transparent; color: var(--ck-orange-500); font-weight: var(--fw-semibold); font-size: var(--fs-sm); cursor: pointer; }
.link-button:hover { text-decoration: underline; }
.link-button:focus-visible { outline: 2px solid var(--ck-orange-500); outline-offset: 2px; }

@media (max-width: 375px) {
  .card { padding: var(--space-6) var(--space-4); }
}
</style>
